import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomConfirmDialog } from '../../../../../../../components/dialogs'

type Props = {
  handleDelete: () => Promise<void>
  length: number
  isVisible: boolean
  onHide: () => void
}

export const DeleteView: React.FC<Props> = ({
  handleDelete,
  length,
  isVisible,
  onHide,
}) => {
  const { t } = useTranslation()

  return (
    <CustomConfirmDialog
      severity="danger"
      isVisible={isVisible}
      header={t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.delete.dialog.title',
        {
          count: length,
        },
      )}
      message={t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.delete.dialog.message',
        {
          count: length,
        },
      )}
      onHide={onHide}
      onReject={onHide}
      onAccept={handleDelete}
      rejectLabel={t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.delete.dialog.cancel.label',
      )}
      acceptLabel={t(
        'deliveryForecastDespatchAdvice.shippingDetails.packagingTable.delete.dialog.delete.label',
      )}
    />
  )
}
